export default function _curry2(fn) {
  	return (a, b) => fn.apply(this,[a,b])
}


// WEBPACK FOOTER //
// ./src/common/bare-metal/private/curry2.js